import { storeManagerEndpoints } from '@/lib/endpoints';
import { service } from '@whiz-cart/node-shared/service/service';
import { createCache } from 'cross-state';

export default service(
    'inventoryManagementSystemService',
    class InventoryManagementSystemService {
        map = createCache(async () => {
            const data = await storeManagerEndpoints.commodityGroups.getInventoryManagementSystems().fetch();
            return new Map(Object.entries(data).map(([name, id]) => [id, name]));
        });
    },
);
